import React from 'react'
import { red_info } from '../../../assets/images'

const Input = ({ type = 'text', name = '', label = '', value = '', disable = false, inputClasses='', error = '', placeholder = '', blurHandler, handler, labelClasses = '', classes = '', subLabel = '', subLabelClasses = '', ...rest }) => {
  labelClasses = labelClasses || 'text-gray-700 font-semibold'
  return (
    <div className={classes}>
      {label && <span className={'block mb-2 '+ labelClasses}>{label}</span>}
      {subLabel && <span className={'block mb-2 '+ subLabelClasses}>{subLabel}</span>}
      <input type={type} name={name} disabled={disable} value={value} placeholder={placeholder} onBlur={blurHandler} onChange={handler} className={`bg-gray-100 border border-gray-200 p-4 pr-7 rounded-md w-full text-gray-300 placeholder-gray-300 font-semibold ${inputClasses}`} {...rest}/>
      {error && <span className='text-red-300 font-sm text-normal flex flex-row'><img src={red_info} style={{marginRight : '5px'}}></img>{error}</span> }
    </div>
  )
}

export default Input
